import { render } from "./input-image-file.vue?vue&type=template&id=70b66fc6&ts=true"
import script from "./input-image-file.vue?vue&type=script&lang=ts"
export * from "./input-image-file.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__